import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommentModalData, CommentsService } from '../comments.service';
import { EntityTypeIds } from 'src/app/constants.new';
import { lastValueFrom } from 'rxjs';
import { InstanceRepository } from 'src/app/Entity/Instance/instance.repository';
import { InstanceRights, RestrictService } from 'src/app/Common/Permissions/restrict.service';
import { UserInstanceService } from 'src/app/User/userInstance.service';
import { MessageModalService } from 'src/app/UI-Lib/Message-Box/messageModal.service';

@Component({
    selector: 'comments-edit',
    templateUrl: 'comments.edit.component.html',
    styleUrls: ['./comments.component.scss'],
    standalone: false,
})
export class CommentsEditComponent implements OnInit {
    @Input() availableCommentTypes: any[];
    @Input() updateComment: any;
    @Input() isNewComment: boolean;
    @Input() entityData: CommentModalData;
    @Input() loading: boolean;
    @Output() cancelEdit: EventEmitter<void> = new EventEmitter();
    @Output() getAllComments: EventEmitter<void> = new EventEmitter();

    constructor(
        private readonly _commentsService: CommentsService,
        private readonly _instanceRepository: InstanceRepository,
        private readonly _restrictService: RestrictService,
        private readonly _userInstanceService: UserInstanceService,
        private readonly _messageModalService: MessageModalService
    ) {}

    areCommentTypesAvailable: boolean = false;
    commentTypes: any[] = [];
    yearIsRelevant: boolean = false;
    availableYears: string[] = [];
    hasInstancePrivateView: boolean = false;
    isSingleRyanInstance: boolean = false;

    ngOnInit() {
        this.yearIsRelevant = this._commentsService.yearIsRelevantForEntityTypeID(this.entityData.entityTypeID);
        this.isSingleRyanInstance = this._userInstanceService.isCurrentInstanceRyan();

        this.areCommentTypesAvailable = this.availableCommentTypes && this.availableCommentTypes.length > 0;
        if (this.areCommentTypesAvailable) {
            this.commentTypes = [{ id: null, name: '' }].concat(
                this.availableCommentTypes.map((item) => {
                    return {
                        id: item.commentTypeID,
                        name: item.commentTypeName,
                    };
                }),
            );
        }

        this.updateComment.BeginAsPinned = this.updateComment.isPinned;

        this._resolveInstancePrivate();
        this._populateYears();
    }

    get valid(): boolean {
        return (
            this.updateComment &&
            this.updateComment.title &&
            (this.updateComment.commentTypeID === 3 ? !!this.updateComment.year : true)
        );
    }

    yearDisabled(): boolean {
        return (
            !!this.entityData.year ||
            this.updateComment.entityTypeID === EntityTypeIds.ASSESSMENT ||
            this.updateComment.entityTypeID === EntityTypeIds.APPEAL ||
            this.updateComment.entityTypeID === EntityTypeIds.TAX_BILL ||
            this.updateComment.entityTypeID === EntityTypeIds.REFUND
        );
    }

    async deleteComment(): Promise<void> {
        if (confirm(`Are you sure you want to delete the comment "${this.updateComment.title}"?`)) {
            await this._commentsService.deleteComment(this.updateComment.commentID);
            this.getAllComments.emit();
        }
    }

    async submitEditForm(): Promise<void> {
        if (this.isNewComment) {
            this.updateComment.entityTypeID = this.entityData.entityTypeID;
            this.updateComment.entityID = this.entityData.entityID;

            var result = await this._commentsService.createComment(this.updateComment);

            if(this.updateComment.isPinned && this.updateComment.year){
                await this._pinComment(this.updateComment.entityID, this.updateComment.entityTypeID, result.commentID);
            }
        } else {
            var result = await this._commentsService.editComment(this.updateComment);
            
            if(this.updateComment.year){
                if(this.updateComment.isPinned){
                    await this._pinComment(this.updateComment.entityID, this.updateComment.entityTypeID, result.commentID);
                } 
                
                if (!this.updateComment.isPinned && this.updateComment.BeginAsPinned) {
                    this._commentsService.unpinComment(this.updateComment.commentID);
                }
            }
        }

        this.getAllComments.emit();
    }

    private async _pinComment(entityID: number, entityTypeID: number, commentID: number){
        var pinnedCommentId = (await this._commentsService.getPinnedComment(entityID, entityTypeID))?.commentID;
        var hasPinned = !!pinnedCommentId;

        if(hasPinned && pinnedCommentId != commentID){
            try {
                await this._messageModalService.confirm('A comment is already pinned. Would you like to replace it with this new one?', 'Confirm');
            } catch (e) {
                return Promise.resolve();
            }
        }

        await this._commentsService.pinComment(commentID)
    }

    private _resolveInstancePrivate() {
        console.log('resolving instance private view');
        lastValueFrom(
            this._instanceRepository.getEntityIdPairInstanceId(this.entityData.entityTypeID, this.entityData.entityID),
        ).then((instanceId) => {
            this.hasInstancePrivateView =
                this._restrictService.hasInstanceRight(InstanceRights.PRIVATEITEMSEDIT, instanceId) ||
                this._restrictService.hasInstanceRight(InstanceRights.PRIVATEITEMSVIEW, instanceId);
        });
    }

    private _populateYears(): void {
        if (this.entityData.year) {
            this.availableYears = [this.entityData.year];

            this.updateComment.year = this.entityData.year;
        } else {
            this.availableYears = [];
            const now = new Date();
            const currentYear = now.getFullYear();

            for (let i = currentYear + 3; i >= currentYear - 10; i--) {
                this.availableYears.push(`${i}`);
            }
        }
    }
}
